module.exports = __webpack_public_path__ + "img/htf2.5cd59dc0.jpg";